module.exports = __webpack_public_path__ + "img/map-pin.75c098c.png";